import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import {
  Form,
  Button,
  Col,
  Row,
  Badge,
} from 'react-bootstrap';
import { insert_new_opportunity } from '../../../../utils/crm_services';
import { loadCountriesData, buildCountrySelectOptions } from '../../../../utils/countries';
import Select from 'react-select';
import './New_opportunity.css';

const typeOptions = [
  { label: 'Public', value: 0 },
  { label: 'Private', value: 1 },
];

const selectStyles = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

function New_opportunity({ channel_name, onSet, token, channel_id }) {
  const navigate = useNavigate();

  const [countryOptions, setcountryOptions] = useState([]);
  const [editableOpportunityName, setEditableOpportunityName] = useState('');
  const [country, setCountry] = useState('');
  const [type, setType] = useState(0);
  const [description, setDescription] = useState('');
  const [closingDate, setClosingDate] = useState('');
  const [protectedUntil, setProtectedUntil] = useState('');

  const handleNameChange = (event) => {
    setEditableOpportunityName(event.target.value);
  };

  const formatOptionLabel = ({ label, flagUrl }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {flagUrl && <img src={flagUrl} alt={`Flag of ${label}`} style={{ width: '20px', marginRight: '10px' }} />}
      <span>{label}</span>
    </div>
  );

  const createNewOpportunity = () => {
    async function fetchcreateNew(name, channelId) {
      const opportunityList = await insert_new_opportunity(
        token,
        name,
        channelId,
        description,
        protectedUntil,
        closingDate,
        country,
        type,
        0,
        'new'
      );
      if (opportunityList === 'INVALID') {
        navigate('/');
      } else {
        navigate('/opportunitypage?id=' + opportunityList);
      }
    }

    fetchcreateNew(editableOpportunityName, channel_id);
  };

  const getOptionByValue = (value) => countryOptions.find((option) => option.value === value);

  const getTypeByValue = (value) => typeOptions.find((option) => option.value === value);

  useEffect(() => {
    loadCountriesData()
      .then((data) => {
        setcountryOptions(buildCountrySelectOptions(data));
      })
      .catch((error) => console.error('Error fetching countries:', error));
  }, []);

  return (
    <div className="new-opportunity-form">
      <div className="modal-inner">
        <Row className="gy-3 align-items-end form-section">
          <Col xs={12} md={channel_name ? 8 : 12}>
            <label className="field-label" htmlFor="new-opportunity-name">
              Opportunity Name
            </label>
            <input
              id="new-opportunity-name"
              type="text"
              className="opportunity-name-field"
              value={editableOpportunityName}
              placeholder="New Opportunity Name"
              onChange={handleNameChange}
            />
          </Col>

          {channel_name ? (
            <Col xs={12} md={4}>
              <div className="channel-badge-wrap">
                <Badge pill bg="primary" className="chip d-inline-flex align-items-center gap-2 px-3 py-2">
                  {channel_name.length > 25 ? channel_name.slice(0, 25) + '...' : channel_name}
                </Badge>
              </div>
            </Col>
          ) : null}
        </Row>

        <div className="form-section">
          <label className="field-label" htmlFor="new-opportunity-description">
            Description
          </label>
          <Form.Control
            id="new-opportunity-description"
            as="textarea"
            rows={4}
            value={description}
            placeholder="Add a brief description..."
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <Row className="gy-3 gx-3 form-section">
          <Col xs={12} sm={6}>
            <label className="field-label" htmlFor="new-opportunity-protection">
              Protection
            </label>
            <Form.Control
              id="new-opportunity-protection"
              type="date"
              value={protectedUntil}
              onChange={(e) => setProtectedUntil(e.target.value)}
            />
          </Col>

          <Col xs={12} sm={6}>
            <label className="field-label" htmlFor="new-opportunity-closing">
              Closing
            </label>
            <Form.Control
              id="new-opportunity-closing"
              type="date"
              value={closingDate}
              onChange={(e) => setClosingDate(e.target.value)}
            />
          </Col>

          <Col xs={12} sm={6}>
            <label className="field-label" htmlFor="new-opportunity-country">
              Country
            </label>
            <Select
              inputId="new-opportunity-country"
              menuPosition="fixed"
              className="react-select-container"
              classNamePrefix="react-select"
              options={countryOptions}
              isLoading={countryOptions.length === 0}
              formatOptionLabel={formatOptionLabel}
              onChange={(selectedOption) => setCountry(selectedOption.value)}
              value={getOptionByValue(country)}
              placeholder="Select country..."
              isSearchable
              styles={selectStyles}
            />
          </Col>

          <Col xs={12} sm={6}>
            <label className="field-label" htmlFor="new-opportunity-type">
              Type
            </label>
            <Select
              inputId="new-opportunity-type"
              menuPosition="fixed"
              className="react-select-container"
              classNamePrefix="react-select"
              options={typeOptions}
              onChange={(selectedOption) => setType(selectedOption.value)}
              placeholder="Select type..."
              value={getTypeByValue(type)}
              styles={selectStyles}
            />
          </Col>
        </Row>
      </div>

      <div className="modal-footer-fixed">
        <Button variant="outline-secondary" onClick={onSet}>
          Cancel
        </Button>
        <Button variant="danger" onClick={createNewOpportunity}>
          Create Opportunity
        </Button>
      </div>
    </div>
  );
}

export default New_opportunity;
